// @ts-strict-ignore
import cx from 'classnames';
import { Text } from 'components/typography';
import { getRandomString } from 'lib/util';
import * as React from 'react';
import { ToggleTagProps } from './ToggleTag.props';

const ToggleTag = ({
  className = '',
  onChange,
  value,
  text,
  id,
  disabled = false,
  dark = false,
  red = false,
  checked,
  icon,
  ...props
}: ToggleTagProps): React.ReactNode => {
  const idRef = React.useRef(getRandomString());

  const tagClasses = cx(
    'z-20 inline-flex cursor-pointer select-none items-center justify-center whitespace-nowrap rounded-full border-thin pb-2 pl-3 pr-3 pt-2 transition duration-1000 xl:pl-4 xl:pr-4',
    {
      'border-gray-700 text-white hover:border-white': dark && !red && !checked,
      'border-black border-opacity-16 hover:border-gray-500 hover:border-opacity-100':
        !dark && !checked,
      'border-black bg-black text-white': !dark && !red && checked,
      'border-black bg-red-700 text-white': red && checked,
      'border-black border-opacity-100 bg-black bg-opacity-60 text-white hover:border-gray-500':
        red && !checked,
      'border-white bg-white text-black': dark && checked
    }
  );
  const iconClasses = cx('ml-1 h-4 w-4 animate-fadeIn', {});
  const Icon = icon;

  const inputId = id || idRef.current;

  return (
    <div className={`relative inline-block ${className}`}>
      <input
        id={inputId}
        type="checkbox"
        value={value || text}
        aria-describedby={`toggle-tag-desc-${inputId}`}
        aria-checked={checked}
        checked={checked}
        onChange={e => {
          if (!disabled) onChange(e);
        }}
        className="tag-input sr-only"
        {...props}
      />
      <Text
        tagName="label"
        className={tagClasses}
        size="m"
        {...{
          htmlFor: inputId,
          id: `toggle-tag-desc-${inputId}`
        }}
      >
        {text}
        {icon && checked && (
          <span className={iconClasses}>
            <Icon />
          </span>
        )}
      </Text>
    </div>
  );
};

export default ToggleTag;
